import * as React from 'react';
import {formatMovieDuration} from "../../utils";
import {MovieInterface} from "../../types";

interface Props {
  movie: MovieInterface;
}

const MoviePageDetails: React.FC<Props> = (props: Props) => {
  const {movie} = props;
  const {director, starring, runTime, promoMovie} = movie;
  const {genre, releaseDate} = promoMovie;

  return (
    <div className="movie-card__text movie-card__row">
      <div className="movie-card__text-col">
        <p className="movie-card__details-item">
          <strong className="movie-card__details-name">Director</strong>
          <span className="movie-card__details-value">{director}</span>
        </p>
        <p className="movie-card__details-item">
          <strong className="movie-card__details-name">Starring</strong>
          <span className="movie-card__details-value">
            {starring.map((star, i) => {
              return (
                <React.Fragment key={star + i}>
                  {star} <br />
                </React.Fragment>
              );
            })}
          </span>
        </p>
      </div>

      <div className="movie-card__text-col">
        <p className="movie-card__details-item">
          <strong className="movie-card__details-name">Run Time</strong>
          <span className="movie-card__details-value">{formatMovieDuration(runTime)}</span>
        </p>
        <p className="movie-card__details-item">
          <strong className="movie-card__details-name">Genre</strong>
          <span className="movie-card__details-value">{genre}</span>
        </p>
        <p className="movie-card__details-item">
          <strong className="movie-card__details-name">Released</strong>
          <span className="movie-card__details-value">{releaseDate}</span>
        </p>
      </div>
    </div>
  );
};

export default MoviePageDetails;
